export const eventDetails = {
  "film-recast": {
    lead: "一次正常的角色调整，因为三版说法出现的时间错位，被读成了「内部撕裂」。真正值得看的不是谁在说谎，而是每一方在什么时间点、为了什么目的开口。",
    keyPoints: [
      "项目官宣与实际开机之间隔了 19 天，这个空窗期是信息发酵的起点。",
      "凌晨发布的通稿把「档期原因」放在第一句，但未提及已完成的定妆与围读。",
      "第三版路透拍摄时间早于官宣，说明现场调整在官宣之前就已发生。",
    ],
    timeline: [
      { time: "9 月 5 日 14:20", text: "项目官微首次发布主演阵容，配图为四人定妆合影。" },
      { time: "9 月 6 日 09:10", text: "有路透显示原定主演未出现在围读现场，剧组未回应。" },
      { time: "9 月 7 日 02:40", text: "剧组发布通稿，称因档期原因调整其中一位主演人选。" },
      { time: "9 月 7 日 11:00", text: "新主演工作室转发通稿，只配了一个「感谢」表情。" },
      { time: "9 月 8 日 16:00", text: "原主演方发出简短说明，强调「双方沟通顺畅」。" },
    ],
    sections: [
      {
        heading: "空窗期里发生了什么",
        paragraphs: [
          "官宣到通稿之间隔着 19 天，这段时间项目方并未发布任何进展说明。信息真空本身就是争议的土壤：观众只能靠零星路透拼图，而路透的拍摄时间往往早于发布时间，很容易被当成「当下的现场」。",
          "对照三版路透的元数据可以看到，最早一版拍摄于官宣次日，也就是阵容公布后的第二天。也就是说，围读缺席并不是突发状况，而是更早的调整在延迟显现。",
        ],
      },
      {
        heading: "通稿为什么选择凌晨发布",
        paragraphs: [
          "凌晨两点四十这个时间点，通常意味着发布方希望把讨论热度压到次日的注意力低谷。但通稿的首句把原因归为「档期」，同时又没有解释已经完成的定妆与围读为何作废，这个缺口反而被放大解读。",
          "从公关节奏上看，这是一个典型的「先定性再补充」写法：先把性质说成常规调整，再指望后续信息自然淡化。但当原主演方在次日傍晚单独发声时，两条口径就出现了并行。",
        ],
      },
      {
        heading: "目前还缺什么信息",
        paragraphs: [
          "截至目前，项目方没有公开调整的具体决策时间，原主演方也未说明合约如何处理。两处空白意味着任何人都无法断言责任归属，能确认的只有一件事：官宣与执行之间存在明显的时间差。",
        ],
      },
    ],
    related: ["poster-billing", "remake-rights", "variety-editing"],
  },
  "variety-editing": {
    lead: "争议的焦点被引向了「谁说了什么」，但把正片和花絮按实际录制顺序排列后会发现，真正被调整的是因果关系的先后。",
    keyPoints: [
      "花絮里同一段对话前后顺序与正片相反，导致动机被重新解读。",
      "争议片段在正片中的时长约 48 秒，花絮中对应素材超过 3 分钟。",
      "节目组在争议后发布的说明只提到「节奏需要」，未解释顺序调整。",
    ],
    timeline: [
      { time: "8 月 30 日 20:00", text: "节目正片播出，争议片段引发第一轮讨论。" },
      { time: "8 月 31 日 10:30", text: "节目组放出未播花絮，同一场景呈现不同氛围。" },
      { time: "8 月 31 日 21:15", text: "相关话题登上热搜，讨论量在两小时内翻倍。" },
      { time: "9 月 1 日 15:00", text: "节目组发布说明，称剪辑以「整体节奏」为准。" },
    ],
    sections: [
      {
        heading: "正片与花絮的差异到底在哪",
        paragraphs: [
          "把两版素材按录制时的实际顺序铺开，差异就很清楚了：正片先呈现情绪落点，再补前因；花絮是按对话自然发生的顺序推进。同样的几句话，换个先后，读者的判断就完全相反。",
          "这不是技术层面的对错问题，而是叙事选择。综艺剪辑压缩时长是常态，48 秒的成片从 3 分钟素材里来并不奇怪，问题在于被删掉的正是解释动机的那几句。",
        ],
      },
      {
        heading: "「节奏需要」解释了什么",
        paragraphs: [
          "节目组的说明用了「整体节奏」这一表述，这在实际操作中是成立的，但它回避了核心疑问：为什么被调整的恰好是消除歧义的顺序，而不是其他部分。",
          "从传播效果看，这份说明没有平息讨论，反而让「是否有意为之」变成了新的议题。当解释不触及具体操作时，读者会默认解释者有所保留。",
        ],
      },
      {
        heading: "这类争议的通用判断方法",
        paragraphs: [
          "遇到剪辑争议，最有效的做法是找原始录制素材或更长版本的花絮，按时间码对齐再看一遍。如果长版本里存在明确的前因，而正片省略了它，那么讨论方向就应该从「谁的性格有问题」转向「为什么省略」。",
        ],
      },
    ],
    related: ["film-recast", "poster-billing", "live-commerce"],
  },
  "concert-ticketing": {
    lead: "加场本是好事，但两版座位图之间存在三个被重新划定的区块。搞清楚区块调整的逻辑，比争论「是否饥饿营销」更有意义。",
    keyPoints: [
      "首场座位图与加场座位图在三个看台区块上存在差异。",
      "加场公告发布距首场售罄仅 3 小时，时间压缩得很紧。",
      "官方未在同一条公告中同步说明两场座位图的版本差异。",
    ],
    timeline: [
      { time: "9 月 2 日 12:00", text: "首场演出开票，票区与座位图同步公布。" },
      { time: "9 月 2 日 15:00", text: "首场显示售罄。" },
      { time: "9 月 2 日 18:10", text: "官宣加场，并发布第二版座位图。" },
      { time: "9 月 3 日 11:30", text: "观众发现两版座位图中 C 区范围不一致。" },
    ],
    sections: [
      {
        heading: "两版座位图差在哪",
        paragraphs: [
          "把两版图叠在一起，差异集中在三个区块：一个是原本标注为「视野受限」的区域在加场中被取消标注；二是舞台侧翼新增了一小片座位；三是某区块的排号起点被前移。",
          "这些调整本身在演出市场并不罕见，舞台搭建方案在不同场次之间会有微调。问题在于调整没有被单独说明，观众只能通过对比旧图自行发现。",
        ],
      },
      {
        heading: "三小时的时间差意味着什么",
        paragraphs: [
          "从售罄到加场公告只有三小时，这个间隔短到不太可能完成完整的方案审批与制图。更合理的解释是，加场的方案在首场开票前就已经准备好，只是在等待首场的销售结果来确认。",
          "这并不构成任何违规，但确实解释了为什么两版座位图会出现不一致——它们是两套并行准备的方案，而非同一套方案的延续。",
        ],
      },
      {
        heading: "购票前值得核对的三件事",
        paragraphs: [
          "第一，确认手中座位图对应的场次版本；第二，核对视野受限区域是否在两场之间发生变动；第三，保留购票时看到的座位图截图，作为后续沟通时的依据。",
        ],
      },
    ],
    related: ["festival-cancel", "fanclub-ledger", "brand-split"],
  },
  "brand-split": {
    lead: "周五撤物料、周日发声明，中间隔的这两天比声明本身信息量更大。把双方的动作按小时排开，博弈的节奏就浮出来了。",
    keyPoints: [
      "品牌方在未提前沟通的情况下撤下全部线上物料。",
      "工作室声明选择在周末深夜发布，避开了工作日的媒体节奏。",
      "双方声明对合作终止原因的表述口径完全不同。",
    ],
    timeline: [
      { time: "8 月 28 日 17:40", text: "品牌方各平台官方账号陆续撤下相关宣传物料。" },
      { time: "8 月 29 日 全天", text: "双方均未任何公开说明，话题开始发酵。" },
      { time: "8 月 30 日 23:20", text: "工作室发布声明，称合约已按流程结束。" },
      { time: "8 月 31 日 09:00", text: "品牌方回应，表述侧重「市场策略调整」。" },
    ],
    sections: [
      {
        heading: "周五傍晚这个时间点",
        paragraphs: [
          "选择在周五傍晚撤下物料，是一个相当典型的公关操作窗口：媒体与公众注意力即将转入周末低谷，即便是突发动作，也很难获得持续的跟进报道。",
          "但这次的效果适得其反。正因为没有任何说明，周末两天里所有解读都只能靠猜测，讨论热度在缺乏官方口径的情况下反而持续累积。",
        ],
      },
      {
        heading: "两份声明的口径差异",
        paragraphs: [
          "工作室的表述是「合约按流程正常结束」，强调程序完备；品牌方的表述是「基于市场策略的调整」，强调主动决策。两份声明都没有说谎，但把它们放在一起看，谁先提出终止这件事就被模糊掉了。",
          "这也是商业合作声明里最常见的处理方式：回避归因，只描述状态。对读者而言，判断的关键不在于声明写了什么，而在于双方是否在同一个时间点采取了一致的动作。",
        ],
      },
      {
        heading: "合作周期里可以核对的线索",
        paragraphs: [
          "品牌与艺人合作的公开周期通常可以从三个地方核对：官宣时间、物料上线与下线的记录、以及双方在合作期内是否共同出席过公开活动。这三条线如果对不上，往往比声明本身更能说明问题。",
        ],
      },
    ],
    related: ["live-commerce", "poster-billing", "fanclub-ledger"],
  },
  "festival-cancel": {
    lead: "开演前 22 小时宣布取消，公告里只有四个字的原因说明。真正影响观众的是退票细则中两处例外条款，逐一拆开来看。",
    keyPoints: [
      "取消公告发布于原定开演前 22 小时，涉及已入场搭建的部分供应商。",
      "退票细则中，改签券与现金退款的处理周期相差近三周。",
      "有两类订单被明确排除在自动退款流程之外。",
    ],
    timeline: [
      { time: "8 月 27 日 20:00", text: "主办方发布公告，宣布次日活动取消。" },
      { time: "8 月 28 日 10:00", text: "票务平台上线自动退款通道。" },
      { time: "8 月 29 日 14:00", text: "部分观众反映含赠品的套票无法自动退款。" },
      { time: "8 月 30 日 16:00", text: "主办方补充说明两类订单的人工处理入口。" },
    ],
    sections: [
      {
        heading: "「不可抗力」之外的信息",
        paragraphs: [
          "公告把原因归纳为不可抗力，这是演出行业的常规表述，也意味着主办方在法律责任上拥有较大空间。但对已经规划行程的观众来说，需要的不是原因定性，而是明确的处理时间表。",
          "从公告发布的时间点看，主办方大概率在当天下午就已经知道无法按期举办，延迟到晚间发布，可能是在等待最后的确认结果。",
        ],
      },
      {
        heading: "两处被排除的订单类型",
        paragraphs: [
          "第一类是包含实体赠品的套票，因为赠品已寄出，系统无法按原金额自动计算；第二类是经由第三方渠道购买的折扣票，由于分销链路较长，需要人工核对订单归属。",
          "这两类订单并非不予退款，而是无法走自动通道。问题在于补充说明的发布时间比公告晚了整整两天，这两天恰好是观众焦虑最高的时候。",
        ],
      },
      {
        heading: "观众现在可以做的",
        paragraphs: [
          "先确认自己的订单类型，再判断是否需要走人工通道；保留购票凭证与公告截图；对于含赠品的套票，可以先确认赠品的物流状态，再提交退款申请，避免因赠品签收影响处理进度。",
        ],
      },
    ],
    related: ["concert-ticketing", "fanclub-ledger", "brand-split"],
  },
  "poster-billing": {
    lead: "一张海报的排版在 47 分钟内改了三次。番位争议的表面是名字位置，底层其实是宣发口径没有统一。",
    keyPoints: [
      "三个版本的海报在 47 分钟内依次替换，改动集中在署名结构。",
      "第二版改为上下结构，与首版左中右排布的逻辑完全不同。",
      "第三版新增的说明文字未在官方渠道同步发布。",
    ],
    timeline: [
      { time: "8 月 24 日 10:00", text: "首版海报发布，采用左中右并列署名结构。" },
      { time: "8 月 24 日 10:26", text: "海报被替换为上下结构版本。" },
      { time: "8 月 24 日 10:47", text: "第三版上线，在署名下方增加一行说明。" },
      { time: "8 月 24 日 13:10", text: "片方回应称只是「排版微调」。" },
    ],
    sections: [
      {
        heading: "47 分钟里改了什么",
        paragraphs: [
          "三版海报的差异并不在视觉风格，而在署名结构。首版左中右并列，隐含三位主演地位相当的暗示；第二版改为上下排布，视觉重心上移；第三版则在下方补了一行说明文字。",
          "三种结构分别对应三种不同的番位理解。改动速度说明这不是设计层面的调整，而是各方在沟通中反复修正口径的过程。",
        ],
      },
      {
        heading: "为什么说明文字最值得注意",
        paragraphs: [
          "相较前两版的纯排版调整，第三版增加的说明文字意味着片方试图用文字补充规则，而不是单靠位置排布暗示。这通常发生在各方对「按什么顺序署名」没有达成一致的时候。",
          "值得注意的是，这行说明并没有出现在片方的官方发布渠道，只存在于海报本身。这让它更像是应急处理，而非正式规则。",
        ],
      },
      {
        heading: "番位争议的一般规律",
        paragraphs: [
          "番位之所以高频出现在话题里，是因为它同时承载了商业价值和情绪价值。判断一次番位争议是否「真的有分歧」，看海报是否在短时间内被反复修改就够了——稳定的番位不会有第二版。",
        ],
      },
    ],
    related: ["film-recast", "remake-rights", "variety-editing"],
  },
  "remake-rights": {
    lead: "三家出品方都说自己拥有改编权利，但三份声明对「权利范围」的定义各不相同。把定义逐条对齐，争议的边界才清晰。",
    keyPoints: [
      "三份声明出现的时间跨度仅两天，但发布时间点都在工作日白天。",
      "其中一份声明将权利限定于「影视改编」，未提及衍生开发。",
      "三份声明均未公开原始授权合同的期限与地域范围。",
    ],
    timeline: [
      { time: "8 月 20 日 11:00", text: "A 方发布声明，称拥有原作的影视改编权。" },
      { time: "8 月 21 日 09:40", text: "B 方回应，强调权利包含衍生开发。" },
      { time: "8 月 21 日 16:20", text: "C 方发布第三份声明，主张优先合作权。" },
      { time: "8 月 22 日 10:00", text: "三方均未再新增说明，争议转入法律层面。" },
    ],
    sections: [
      {
        heading: "三份声明的关键词差异",
        paragraphs: [
          "把三份声明并排来看，分歧集中在两个词：一是「影视改编」是否包含衍生开发，二是「优先合作权」是否构成排他性权利。这两个词在法律上的差别巨大，但在传播中经常被混为一谈。",
          "有意思的是，三方都很有默契地没有公开合同的期限与地域范围。这恰恰是判断权利归属最核心的两项信息。",
        ],
      },
      {
        heading: "为什么都不公开合同细节",
        paragraphs: [
          "跨境版权合同通常包含保密条款，公开细节可能直接构成违约。因此三方的声明本质上都是「表态」而非「举证」，它们的作用是稳定各自的市场预期，而不是解决法律争议。",
          "这也解释了为什么争议没有在公共舆论层面继续升级——当各方都清楚真正的战场在合同里时，反复发声明只会消耗公众耐心。",
        ],
      },
      {
        heading: "读者可以关注什么",
        paragraphs: [
          "对于这类争议，与其争论谁更占理，不如关注后续是否出现联合出品、或者某一方宣布项目立项。实际动作永远比声明更能反映权利的真实分布。",
        ],
      },
    ],
    related: ["film-recast", "poster-billing", "brand-split"],
  },
  "live-commerce": {
    lead: "争议的落点集中在「谁负责质检」。把选品、上架、讲解、售后四个环节各方的表态排出来，会发现有一段责任是空着的。",
    keyPoints: [
      "选品环节由招商团队完成，主播方称未参与实物审核。",
      "上架与讲解之间存在 36 小时的时间差，样品状态未被重新确认。",
      "售后责任在平台规则与商家承诺之间存在明显缺口。",
    ],
    timeline: [
      { time: "8 月 16 日 14:00", text: "招商团队完成选品，样品进入主播团队备货流程。" },
      { time: "8 月 17 日 20:00", text: "商品上架，商品页标注质检合格信息。" },
      { time: "8 月 18 日 20:00", text: "直播讲解，样品展示与商品页信息一致。" },
      { time: "8 月 19 日 10:00", text: "消费者反馈收到商品与样品不符，售后启动。" },
    ],
    sections: [
      {
        heading: "四个环节里空掉的那一段",
        paragraphs: [
          "把链路拆开：招商团队负责选品与资质初审，主播团队负责讲解与展示，平台负责规则与流量，商家负责发货与售后。四个环节看起来完整，但「上架到大货生产」这一段没有任何一方明确负责。",
          "36 小时的时间差正好落在这里。上架时确认的样品，和最终抵达消费者手中的大货，中间没有任何一环做了实物比对。",
        ],
      },
      {
        heading: "主播方的责任边界在哪",
        paragraphs: [
          "主播方称未参与实物审核，这个说法在流程上成立。但在直播这种强信任场景中，观众的购买决策很大程度上依赖讲解者的背书，而不是平台规则。责任边界与信任边界不一致，正是争议的根源。",
          "目前行业内的通行做法是要求主播方对展示样品负责，但对大规模生产批次不做逐批确认。这留下了一个结构性缺口。",
        ],
      },
      {
        heading: "消费者维权的实操顺序",
        paragraphs: [
          "第一步确认商品页与实物是否一致，保留开箱视频；第二步通过平台售后通道提交，同时记录沟通时间；第三步如未解决，再依据商品页标注的质检信息追溯责任方。顺序很重要，跳过平台直接找主播方往往会延长处理周期。",
        ],
      },
    ],
    related: ["brand-split", "fanclub-ledger", "festival-cancel"],
  },
  "fanclub-ledger": {
    lead: "一份 12 页的账目明细，看起来足够透明。但逐条核对之后，有三类支出只有总额，找不到对应的凭证说明。",
    keyPoints: [
      "账目公开了 12 页明细，覆盖周期为 14 个月。",
      "三类支出只列总额，未说明单笔对应的活动名称。",
      "公开文件中约 62% 的条目出示了电子凭证缩略图。",
    ],
    timeline: [
      { time: "8 月 12 日 21:00", text: "后援会发布账目明细，共 12 页。" },
      { time: "8 月 13 日 20:00", text: "成员反馈部分支出缺少凭证说明。" },
      { time: "8 月 14 日 12:00", text: "后援会补充说明，称部分凭证涉及隐私。" },
      { time: "8 月 15 日 09:00", text: "完整凭证未再公开，讨论逐渐降温。" },
    ],
    sections: [
      {
        heading: "12 页里被跳过的部分",
        paragraphs: [
          "账目明细本身结构清晰，按活动分列了收入与支出。问题出在汇总环节：有三类支出以「活动综合费用」的名义列出，只有总额，没有对应到具体的活动或时间。",
          "在自愿公开的场景中，这种处理并不罕见，因为细化到单笔确实涉及参与成员的个人信息。但当总额达到一定比例时，公众的疑问就不是隐私问题，而是透明度问题。",
        ],
      },
      {
        heading: "「涉及隐私」这个理由站得住吗",
        paragraphs: [
          "部分成立。参与成员的交通、住宿信息确实不宜公开。但可以通过打码、只公开金额与类别的方式处理，而不是直接把整类支出合并。",
          "对比另外 62% 提供了凭证缩略图的条目可以看出，后援会本身是具备公开能力的，只是在这三类支出上选择了更粗略的处理方式。",
        ],
      },
      {
        heading: "判断账目公开是否充分的方法",
        paragraphs: [
          "看三点：每一项支出是否能对应到具体活动、金额与凭证能否对上、以及未公开的部分是否给出了可核验的替代说明。三点里缺一点可以理解，缺两点就值得追问。",
        ],
      },
    ],
    related: ["festival-cancel", "live-commerce", "brand-split"],
  },
};